import React, { FC, PropsWithChildren } from 'react';

import { Box, Heading, Text, Link, Image } from '@lucid/components-react';
import reactHTMLParser from 'html-react-parser';
import { getProcessedValue } from '@lucid/utils';
import { Drupal_ParagraphFlexiSection } from 'generated/drupal-graphql';

import { LucidTheme } from 'types/types';

interface CenteredHeaderUnderProps {
  entity: Drupal_ParagraphFlexiSection;
}

const CenteredHeaderUnder: FC<PropsWithChildren<CenteredHeaderUnderProps>> = ({ entity }) => (
  <Box
    css={{ label: 'flexiStyledSectionCenteredHeaderUnder' }}
    gridColumn={{ default: '1 / -1', tablet: '3 / -3' }}
    mb={11}
  >
    <Box overflow="visible" px={{ default: 0, tablet: 6 }}>
      <Box css={{ textAlign: 'center' }} mb={{ default: 4, tablet: 6 }} mx={{ default: -11, tablet: 'auto' }}>
        <Image imageAlt="" imageSrc={entity.fieldFlexiImage || ''} loading="lazy" />
      </Box>
      <Box maxWidth={{ default: '100%', tablet: '580px' }} mx="auto">
        <Text
          as="div"
          css={{
            '& > p': {
              marginTop: 0,
            },
          }}
          variant="paragraphS400"
        >
          {reactHTMLParser(getProcessedValue(entity.fieldFlexiBody))}
        </Text>
      </Box>
      <Heading
        as="h2"
        css={(theme: LucidTheme) => ({
          marginBottom: theme.space[7],
          textAlign: 'center',
        })}
        variant="headline2XL"
      >
        {entity.fieldFlexiHeader}
      </Heading>
      <Box css={{ display: 'flex', justifyContent: 'center' }}>
        <Link displayAsButton href={entity.fieldFlexiLink?.url?.path || ''}>
          {entity.fieldFlexiLink?.title}
        </Link>
      </Box>
    </Box>
  </Box>
);

export default CenteredHeaderUnder;
